/**
 * Not implemented.
 */

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { EventsManagementComponent } from "./events-management.component";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        EventsManagementComponent
    ],
    exports: [
        EventsManagementComponent
    ]
})
export class EventsManagementModule {
}
